import {
    FileInfo, WritingOptions, DownloadOptions, 
    FileSystemDownloadResult, ReadingOptions
} from './FileSystem';
import SparkMD5 from 'spark-md5';

let memory = {};

export class MemoryFsInode {
    info: FileInfo;
    data: string;
}

export class MemoryFs {
    documentDirectory:string = '/documents/';
    async getInfoAsync(
        fileUri: string,
        options: { md5?: boolean; size?: boolean }
    ): Promise<FileInfo> {
        if (!memory[fileUri]) {
            return {
                exists: false, 
                uri: fileUri, 
                size: 0, 
                isDirectory: false,
                modificationTime: null, 
                md5: null
            } as FileInfo;
        }
        return memory[fileUri].info;
    };
    async downloadAsync(uri: string, fileUri: string, options: DownloadOptions = {}): Promise<FileSystemDownloadResult> {
        let res:FileSystemDownloadResult = {
            headers: {},
            status: null,
            mimeType: "",
            uri: uri
        };
        
        let response = await fetch(uri);
        response.headers.forEach((value, key) => {
            res.headers[key] = value;
        });
        res.status = response.status;
        res.mimeType = response.headers.get('content-type');

        this.writeAsStringAsync(fileUri, response.blob().toString(), { encoding: 'utf8' });

        return res;
    };
    async moveAsync(options: { from: string; to: string }):Promise<void> {
        memory[options.to] = memory[options.from];
        memory[options.to].info.uri = options.to;
        delete memory[options.to];
    };
    async copyAsync(options: { from: string; to: string }): Promise<void> {
        let inode:MemoryFsInode = {
            data: memory[options.from].data,
            info: JSON.parse(JSON.stringify(memory[options.from].info)) as FileInfo
        };
        inode.info.uri = options.to;

        memory[options.to] = inode;
    };
    async writeAsStringAsync(fileUri: string, contents: string, options: WritingOptions = {}): Promise<void> {
        let inode:MemoryFsInode = {
            data: contents,
            info: {
                exists: false, 
                uri: fileUri, 
                size: 0, 
                isDirectory: false,
                modificationTime: null, 
                md5: null
            } as FileInfo
        };
        inode.info.md5 = SparkMD5.hash(contents);
        memory[fileUri] = inode;
    };
    async readAsStringAsync(fileUri: string, options?: ReadingOptions): Promise<string> {
        if (!memory[fileUri]) {
            throw new Error("File does not exist: " + fileUri);
        }
        return memory[fileUri].data;
    };
    async deleteAsync(
        fileUri: string,
        options: { idempotent?: boolean } = {}
      ): Promise<void> {
        delete memory[fileUri];
      };
}